// extracted by mini-css-extract-plugin
export default {"Layout":"Layout_Layout__rPmUI","row":"Layout_row__Zm9qs","col":"Layout_col__su4ph"};